module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', [_vm._v("Eat Your Feelings")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("The "), _c('strong', [_vm._v("FOOD MOOD GIRL’S")]), _c('br'), _c('strong', [_vm._v("GUIDE")]), _vm._v(" to "), _c('strong', [_vm._v("TRANSFORMING"), _c('br'), _vm._v("YOUR EMOTIONAL EATING")])]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("LINDSEY SMITH")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "OEBPS/images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1daa1e9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 63
// module chunks = 0